var map = {
	"./audio-placeholder": 756,
	"./audio-placeholder.png": 756,
	"./avatar-missing": 561,
	"./avatar-missing.png": 561,
	"./avatar-missing.svg": 784,
	"./header-missing": 567,
	"./header-missing.png": 567,
	"./soapbox-logo": 568,
	"./soapbox-logo-white": 569,
	"./soapbox-logo-white.svg": 569,
	"./soapbox-logo.svg": 568,
	"./video-placeholder": 757,
	"./video-placeholder.png": 757,
	"./void": 758,
	"./void.png": 758,
	"./web-push/web-push-icon_expand": 768,
	"./web-push/web-push-icon_expand.png": 768,
	"./web-push/web-push-icon_favourite": 769,
	"./web-push/web-push-icon_favourite.png": 769,
	"./web-push/web-push-icon_reblog": 770,
	"./web-push/web-push-icon_reblog.png": 770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 783;